import { useTranslation } from "react-i18next";
import Modal from "@/components/modal";
import MailPreferencesForm from "@/components/mailTemplate/mailPreferencesForm";

export default function MailPreferencesDialog({
  subjectId,
  onClose,
  templateTraceId,
}: {
  subjectId: string;
  onClose: () => void;
  templateTraceId?: string;
}) {
  const { t } = useTranslation();

  return (
    <Modal
      open
      title={t("mail_preferences_title")}
      onClose={onClose}
      hideSubmitButton
      cancelButtonText={t("close")}
      maxWidth="1000px"
    >
      <MailPreferencesForm
        subjectId={subjectId}
        templateTraceId={templateTraceId}
      />
    </Modal>
  );
}
